export let startTransaction = async (requestUrl, requestData) => {
    let {data} = await axios.post(requestUrl, requestData);

    Datatrans.startPayment({
        transactionId: data.transactionId,
    });
}

export let loadPaymentScripts = (testing) => {
    let datatransScript = document.createElement('script')
    if (testing) {
        datatransScript.setAttribute('src', 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js')
    } else {
        datatransScript.setAttribute('src', 'https://pay.datatrans.com/upp/payment/js/datatrans-2.0.0.js')
    }

    document.head.appendChild(datatransScript)
}
